import React from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import {
  Alert,
  Button,
  ButtonType
} from 'syngenta-digital-cropwise-react-ui-kit';
import { INTEGRATIONS } from 'screens/Integrations/helpers/constants';
import useSessionStorage from 'hooks/useSessionStorage';

const SESSION_KEY = 'calag-near-school-alert-dismissed';

interface AlertNearToSchoolProps {
  integrationType: string;
}

const AlertNearToSchool = ({ integrationType }: AlertNearToSchoolProps) => {
  const { feIntegrationsDisplayAlertCalagNearSchool } = useFlags();
  const { storedValue: dismissed, setValue: setDismissed } = useSessionStorage(
    SESSION_KEY,
    false
  );

  if (
    integrationType !== INTEGRATIONS.calAgPermits ||
    !feIntegrationsDisplayAlertCalagNearSchool ||
    dismissed
  ) {
    return null;
  }

  const handleDismiss = () => {
    setDismissed(true);
  };

  return (
    <Alert
      className="mb-4 py-3 px-4"
      closeText={
        <Button type={ButtonType.outline} size="small" onClick={handleDismiss}>
          Dismiss
        </Button>
      }
      message={null}
      description={
        <span>
          As of Jan 1, 2026 the California Code of Regulations were updated to
          require additional information for production agriculture sites within
          1/4 mile of a school or child care facility. For more information
          please review the{' '}
          <a
            href="https://www.cdpr.ca.gov/cac-letter/new-notification-and-reporting-requirements-for-pesticide-use-near-schoolsites/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
          >
            California Department of Pesticide Regulation new requirements
          </a>
        </span>
      }
      showIcon
      type="info"
    />
  );
};

export default AlertNearToSchool;
